import { mapState } from 'vuex'
import { loading } from '@/mixin'
import { Uploader, Loading, Toast, Popup, Notify, Dialog } from 'vant'
import logoImg from '@/assets/logo.png'
import qrCodeImg from '@/assets/you-plus-wechat-qrcode.jpg'
import illuImg from '@/assets/internship-challenge-illustration.png'
import awardImg from '@/assets/internship-challenge-template.png'
import html2canvas from 'html2canvas'
import { setCookIntChallStatus, getIntChallStatus } from '@/util/auth'
import { uploadFileWithSign } from '@/api/file'

export const common = {
  name: 'InternshipChallenge',
  components: {
    VanUploader: Uploader,
    VanLoading: Loading,
    VanPopup: Popup,
    VanDialog: Dialog
  },
  data() {
    return {
      title: ['PwC You Plus', 'Internship Challenge', 'Season Ⅱ'],
      cookieObj: {
        language: 1,
        pageStatus: 0,
        leadId: ''
      },
      fileList: [],
      bg: '',
      avatarList: [],
      previewMode: false,
      showPopup: false,
      imgUrl: '',
      imgWidth: '',
      imgHeight: '',
      pagePara: {},
      score: 100,
      userName: '',
      logoImg,
      qrCodeImg,
      illuImg,
      awardImg,
      pageLoading: false
    }
  },
  mixins: [loading],
  computed: {
    cLoading() {
      return this.pageLoading
    },
    ...mapState(['loading'])
  },
  mounted() {
    // 随机背景图
    let num = Math.floor(Math.random() * 5)
    num++
    this.bg = 'bg-' + num
    // 获取参数
    this.pagePara = this.$route.query
    this.userName = this.pagePara.sojumpparm.split('|')[1]
    this.cookieObj.leadId = this.pagePara.sojumpparm.split('|')[0]
    this.score = Number(this.pagePara.totalvalue) + 100

    // getIntChallStatus
    const intChallStatus = getIntChallStatus() || {}
    if (Object.keys(intChallStatus).length > 0) {
      this.cookieObj = intChallStatus
    }
    console.log(this.cookieObj)

    // Toast.setDefaultOptions({ duration: 50000 })
  },
  methods: {
    // 切换语言
    changeLang() {
      if (this.cookieObj.language === 0) {
        this.cookieObj.language = 1
      } else {
        this.cookieObj.language = 0
      }
      setCookIntChallStatus(this.cookieObj)
    },
    onOversize(file) {
      Notify('请上传小于5M的文件')
    },
    // 选择简历
    beforeRead(file, detail) {
      if (file) {
        const accept = '.jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PNG,.PDF'
        if (Array.isArray(file)) {
          const result = []
          for (let i = 0; i < file.length; i++) {
            const item = file[i]
            const flieArr = item.name.split('.')
            const suffix = flieArr[flieArr.length - 1] || ''
            if (!accept.includes(suffix)) {
              result.push(false)
              Toast('请上传jpg/png/pdf格式文档')
              break
            }
            if (item.size <= 0) {
              result.push(false)
              Notify({
                message: '因系统兼容问题,无法获取文件内容,请尝试使用手机系统浏览器或PC端chrome浏览器打开页面提交',
                duration: 5 * 1000
              })
              break
            }
          }
          return !result.includes(false)
        } else {
          const flieArr = file.name.split('.')
          const suffix = flieArr[flieArr.length - 1] || ''
          if (!accept.includes(suffix)) {
            Toast('请上传jpg/png/pdf格式文档')
            return false
          }
          if (file.size <= 0) {
            Notify({
              message: '因系统兼容问题,无法获取文件内容,请尝试使用手机系统浏览器或PC端chrome浏览器打开页面提交',
              duration: 5 * 1000
            })
            return false
          }
          return true
        }
      } else {
        Notify({
          message: '因系统兼容问题,无法获取文件内容,请尝试使用手机系统浏览器或PC端chrome浏览器打开页面提交',
          duration: 5 * 1000
        })
        return false
      }
    },
    // 上传简历
    async afterRead(val) {
      if (this.fileList.length > 0) {
        this.pageLoading = true
        const fd = new FormData()
        this.fileList.forEach(item => {
          fd.append('files', item.file)
        })
        fd.append('sojumpparm', this.pagePara.sojumpparm)
        const score = this.score.toString()
        fd.append('score', score)
        const res = uploadFileWithSign(fd)
        if (res && res.resultCode === '0') {
          Toast.success('简历上传成功')
        } else {
          Toast.fail('简历上传失败')
        }
        setTimeout(() => {
          this.cookieObj.pageStatus = 1
          this.pageLoading = false
          setCookIntChallStatus(this.cookieObj)
          this.$nextTick(() => {
            this.$refs.inputBox.focus()
          })
        }, 600)
      } else {
        Toast.fail('请选择简历')
      }
    },
    // 上传头像
    async afterReadAvatar(isPc) {
      if (this.avatarList.length > 0) {
        this.pageLoading = true
        const fd = new FormData()
        this.avatarList.forEach(item => {
          fd.append('files', item.file)
        })
        fd.append('sojumpparm', this.pagePara.sojumpparm)
        fd.append('isAvatar', true)
        const res = await uploadFileWithSign(fd)
        if (res && res.resultCode === '0') {
          Toast.success('头像上传成功')
          if (isPc) {
            this.pcGenerateImg() // 电脑端生成并下载海报
          } else {
            this.generateImg() // 移动端生成图片
          }
        } else {
          Toast.fail('头像上传失败')
        }
      } else {
        Toast.fail('请选择头像')
      }
    },
    // 手机端生成图片
    createImg() {
      if (this.cookieObj.pageStatus === 1 && this.avatarList.length === 0) {
        Dialog.confirm({
          title: '请上传头像',
          message: '请务必上传个人真实专业照片做为头像，一旦生成海报后将不可修改。',
          confirmButtonText: '上传头像'
        }).then(() => {
          this.$refs['uploadAvatar'].chooseFile()
        })
      } else {
        if (this.cookieObj.pageStatus === 2 && this.imgUrl !== '') {
          this.showPopup = true
        } else {
          this.generateImg()
        }
      }
    },
    // 手机端生成图片
    generateImg() {
      this.pageLoading = true
      this.previewMode = true
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.$nextTick(() => {
        const box = this.$refs.shaBox
        this.imgWidth = box.clientWidth // 获取dom宽度
        this.imgHeight = box.clientHeight // 获取dom高度
        const opts = {
          scale: 3, // 定义任意放大倍数 支持小数
          width: this.imgWidth,
          height: this.imgHeight,
          scrollX: 0,
          scrollY: 0,
          dpi: 72
        }
        setTimeout(() => {
          html2canvas(box, opts).then(canvas => {
            const dataUrl = canvas.toDataURL('image/png', 1)
            this.imgUrl = dataUrl
            if (this.imgUrl !== '') {
              this.showPopup = true
              this.pageLoading = false
              Toast.success('图片生成成功')
              this.previewMode = false
            }
          }).catch(err => {
            console.log(err)
          })
        }, 600)
      })
    },
    // 关闭弹框
    closePopup() {
      if (this.cookieObj.pageStatus === 1) {
        this.imgUrl = ''
      }
      this.cookieObj.pageStatus = 2
      setCookIntChallStatus(this.cookieObj)
    },
    // //  移动端生成图片
    // createPoster() {
    //   if (this.cookieObj.pageStatus === 1 && this.avatarList.length === 0) {
    //     Dialog.confirm({
    //       title: '请上传头像',
    //       message: '请务必上传个人真实专业照片做为头像，一旦生成海报后将不可修改。',
    //       confirmButtonText: '上传头像'
    //     }).then(() => {
    //       this.$refs['uploadAvatar'].chooseFile()
    //     })
    //   } else {
    //     this.afterReadAvatar()
    //   }
    // },
    // 生成图片
    createPoster(isPc) {
      if (this.cookieObj.pageStatus === 1 && this.avatarList.length === 0) {
        Dialog.confirm({
          title: '请上传头像',
          message: '请务必上传个人真实专业照片做为头像，一旦生成海报后将不可修改。',
          confirmButtonText: '上传头像'
        }).then(() => {
          this.$refs['uploadAvatar'].chooseFile()
        })
      } else {
        if (isPc === 'pc') {
          this.afterReadAvatar(true)
        } else {
          this.afterReadAvatar()
        }
      }
    },
    // 电脑生成并下载图片
    pcGenerateImg() {
      this.previewMode = true
      this.pageLoading = true
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.$nextTick(() => {
        const box = this.$refs.shaBox
        // this.imgWidth = box.clientWidth // 获取dom宽度
        this.imgHeight = box.clientHeight // 获取dom高度
        console.log('width', this.imgWidth)
        console.log('height', this.imgHeight)
        const opts = {
          scale: 3, // 定义任意放大倍数 支持小数
          width: 360,
          height: this.imgHeight,
          scrollX: 0,
          scrollY: 0,
          dpi: 72
        }
        setTimeout(() => {
          html2canvas(box, opts).then(canvas => {
            this.imgUrl = canvas.toDataURL('image/jpg', 1) // 下载链接
            let fileName = ''
            if (this.cookieObj && this.cookieObj.pageStatus === 1) {
              fileName = '成绩分享-' + new Date().getTime() + '.jpg'
            } else {
              fileName = '参赛证书-' + new Date().getTime() + '.jpg'
            }
            // 下载图片（微信上无效）
            const link = document.createElement('a')
            link.href = this.imgUrl // 下载链接
            link.setAttribute('download', fileName)
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            this.previewMode = false
            this.pageLoading = false
            this.cookieObj.pageStatus = 2
            setCookIntChallStatus(this.cookieObj)
            Toast.success('图片下载成功')
          })
        }, 600)
      })
    }
  }
}
